export const MAX_SUBMISSIONS = 50000;
